/**
 * Max file size supported by File Management
 */
export const MAX_FILE_SIZE_MB = 10;
/**
 * File Management Api Version used by the file upload components
 */
export const API_VERSION = 1;
/**
 * Application Stages
 */
export var Stage;
(function (Stage) {
    Stage["LOCAL"] = "local";
    Stage["SANDBOX"] = "sandbox";
    Stage["DEV"] = "dev";
    Stage["PROD"] = "prod";
})(Stage || (Stage = {}));
/**
 * Maps application stages to corresponding File Management endpoints
 */
export const stageToEndpoint = {
    [Stage.LOCAL]: `http://localhost:4000/ci/v${API_VERSION}`,
    [Stage.SANDBOX]: `https://api.sandbox.treez.io/file/v${API_VERSION}`,
    [Stage.DEV]: `https://api.dev.treez.io/file/v${API_VERSION}`,
    [Stage.PROD]: `https://api.mso.treez.io/file/v${API_VERSION}`,
};
